import React from 'react';
import styles from './HDFormatWrapper.module.css';

/**
 * PatientDemographicsHeader - HD report style demographics header
 *
 * Displays patient information in the standard HD report format:
 * [NEURULA Logo] | [Organization Info] | [Patient Demographics]
 *
 * @param {Object} patient - Patient demographics object
 * @param {string} patient.mrn - Medical Record Number
 * @param {string} patient.name - Full patient name (e.g., "John Michael Doe")
 * @param {string} patient.gender - Gender (Male/Female/Other)
 * @param {number} patient.age - Patient age
 * @param {string} patient.dob - Date of birth (YYYY-MM-DD format)
 */
const PatientDemographicsHeader = ({ patient }) => {
  if (!patient) {
    return null; // Graceful fallback
  }

  const { mrn, name, gender, age, dob } = patient;

  // Format date for display
  const formatDob = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    } catch {
      return dateString; // Return as-is if parsing fails
    }
  };

  return (
    <div className={styles.headerSection}>
      {/* Left: Brand Name */}
      <div className={styles.headerLeft}>
        <div className={styles.brandName}>NEURULA</div>
      </div>

      {/* Center: Organization Info */}
      <div className={styles.headerCenter}>
        <div className={styles.orgName}>Neurula Health</div>
        <div className={styles.orgTagline}>Digital Healthcare Solutions</div>
      </div>

      {/* Right: Patient Demographics */}
      <div className={styles.headerRight}>
        <div className={styles.patientInfoRow}>
          <span className={styles.label}>MRN</span>
          <span className={styles.value}>{mrn || 'N/A'}</span>
        </div>
        <div className={styles.patientInfoRow}>
          <span className={styles.label}>Patient Name</span>
          <span className={styles.value}>{name || 'N/A'}</span>
        </div>
        <div className={styles.patientInfoRow}>
          <span className={styles.label}>Gender</span>
          <span className={styles.value}>{gender || 'N/A'}</span>
        </div>
        <div className={styles.patientInfoRow}>
          <span className={styles.label}>Age / DOB</span>
          <span className={styles.value}>
            {age || 'N/A'} / {formatDob(dob)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PatientDemographicsHeader;
